import actions from "./actions";

export const POI_RENDER = "poi.rendered";

export default {
  ...actions,
};



// WEBPACK FOOTER //
// ./assets/pois/constants/index.js